/**
 * Ordered Breakpoints
 * Units in px instead of rem to support arbitrary min-* and max-* styling.
 * @warn keys must be ordered in increasing size, so that consumer logic don't have to sort it
 * @see https://www.figma.com/design/ulUeUVSNgLMAYaeH0nJxCI/Den-Components?node-id=17128-10515&m=dev
 */
export const screen = {
  /** 20rem */
  xs: '320px',
  /** 40rem */
  sm: '640px',
  /** 48rem (tablet size starts) */
  md: '768px',
  /** 64rem (desktop size starts) */
  lg: '1024px',
  /** 80rem */
  xl: '1280px',
  /** 90rem */
  '2xl': '1440px',
  /** 120rem */
  '3xl': '1920px',
} as const;
